import type { QuestionObject, GetAnswerFunc } from 'landing_pages/types'
import { matchesRuleCondition } from './matches-rule-condition'

export function getVisibleQuestions(questions: QuestionObject[], getAnswer: GetAnswerFunc) {
  return questions.filter(question => !question.dependentOnQuestionKey || matchesRuleCondition(getAnswer(question.dependentOnQuestionKey), { operator: question.dependentOnOperator, value: question.dependentOnValue }))
}
